document.addEventListener("DOMContentLoaded", function () {

  // -----------------------------------------------
  // 1. Smooth Scroll for anchor links
  //    Eigene Animation statt scrollIntoView: ruhiges Tempo, weiches Ein-/Ausrollen
  //    und das Ziel landet in der Bildschirmmitte statt oben am Rand.
  // -----------------------------------------------
  var smoothScrollFrame = null;

  function cancelSmoothScroll() {
    if (smoothScrollFrame !== null) {
      cancelAnimationFrame(smoothScrollFrame);
      smoothScrollFrame = null;
      document.documentElement.style.scrollBehavior = '';
    }
  }

  // Sobald der Nutzer selbst scrollt, geben wir die Kontrolle sofort zurueck
  ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, cancelSmoothScroll, { passive: true });
  });

  function scrollTargetFor(targetEl) {
    var header    = document.querySelector('header');
    var headerH   = header ? header.getBoundingClientRect().height : 0;
    var rect      = targetEl.getBoundingClientRect();
    var elTop     = rect.top + window.pageYOffset;
    var viewport  = window.innerHeight;
    var dest;

    if (rect.height + headerH + 32 <= viewport) {
      // Passt komplett auf den Schirm → mittig ausrichten
      dest = elTop - (viewport - rect.height) / 2;
    } else {
      // Hoeher als der Schirm → oberer Rand knapp unter den festen Header
      dest = elTop - headerH - 24;
    }

    var maxScroll = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    ) - viewport;

    return Math.max(0, Math.min(dest, maxScroll));
  }

  function smoothScrollToEl(targetEl) {
    cancelSmoothScroll();

    var dest  = scrollTargetFor(targetEl);
    var start = window.pageYOffset;
    var dist  = dest - start;

    if (Math.abs(dist) < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, dest);
      return;
    }

    // Bewusst gemaechlich: mindestens 1,0 s, bei langen Wegen bis 2,0 s
    var duration = Math.min(2000, Math.max(1000, Math.abs(dist) * 0.8));
    var startTime = null;

    // CSS scroll-behavior:smooth wuerde gegen die eigene Animation arbeiten
    document.documentElement.style.scrollBehavior = 'auto';

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function step(now) {
      if (startTime === null) startTime = now;
      var t = Math.min(1, (now - startTime) / duration);
      window.scrollTo(0, start + dist * easeInOutCubic(t));

      if (t < 1) {
        smoothScrollFrame = requestAnimationFrame(step);
      } else {
        smoothScrollFrame = null;
        document.documentElement.style.scrollBehavior = '';
      }
    }

    smoothScrollFrame = requestAnimationFrame(step);
  }

  document.querySelectorAll('a.scroll-link').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#') + 1) : null;
      var targetEl = hash ? document.getElementById(hash) : null;
      if (targetEl) {
        e.preventDefault();
        smoothScrollToEl(targetEl);
      }
      // Wenn Element nicht auf dieser Seite → normale Navigation (Browser scrollt nach Laden)
    });
  });

  // Nach Seitenload: falls Hash in URL, zu Element scrollen
  if (window.location.hash) {
    var hashEl = document.getElementById(window.location.hash.substring(1));
    if (hashEl) {
      setTimeout(function () {
        smoothScrollToEl(hashEl);
      }, 300);
    }
  }

  // -----------------------------------------------
  // 2. Scroll Reveal Animations
  // -----------------------------------------------
  var reveals = document.querySelectorAll('.reveal');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, {
    root: null,
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });
  reveals.forEach(function (el) { revealObserver.observe(el); });

  // -----------------------------------------------
  // 3. Mobile Menu & Cart Drawer
  // -----------------------------------------------
  var mobileMenuBtn     = document.getElementById('mobile-menu-btn');
  var mobileMenuWrapper = document.getElementById('mobile-menu-wrapper');
  var mobileMenuIcon    = document.getElementById('mobile-menu-icon');
  var mobileLinks       = document.querySelectorAll('.mobile-nav-link');

  var cartToggleBtn     = document.getElementById('cart-toggle-btn');
  var cartWrapper       = document.getElementById('cart-wrapper');
  var cartContainer     = document.getElementById('cart-items-container');

  var isMenuOpen = false;
  var isCartOpen = false;
  var liveCartCount = 0;
  var liveCartTotal = 0;
  // Summe und Anzahl der Artikel, die ueberhaupt Versand kosten koennen
  // (Aktionsprodukte zaehlen nicht mit – so rechnet auch Shopify im Checkout,
  //  weil die Aktionsprodukte in einem eigenen Versandprofil liegen).
  var liveChargeTotal = 0;
  var liveChargeCount = 0;
  // Summe, an der die Gratisgrenze gemessen wird. Standard: die ganze Bestellsumme –
  // genau das prueft auch Shopify im Checkout.
  var liveProgressTotal = 0;

  // Varianten der Aktion „Versandkostenfrei" (aus sections/header.liquid)
  var fsFreeVariants = {};
  (function () {
    var list = (window.EkaCare && window.EkaCare.freeShippingVariants) || [];
    for (var i = 0; i < list.length; i++) fsFreeVariants[String(list[i])] = true;
  })();
  var fsFreeLabel = (window.EkaCare && window.EkaCare.freeShippingLabel) || 'Versandkostenfrei';
  // true = Aktionsartikel zaehlen zur Gratisgrenze (Shopify-Standard)
  var fsPromoCounts = !(window.EkaCare && window.EkaCare.freeShippingPromoCounts === false);

  function fsIsFreeVariant(variantId) {
    return variantId != null && fsFreeVariants[String(variantId)] === true;
  }


  function closeMenu() {
    isMenuOpen = false;
    if (mobileMenuWrapper) mobileMenuWrapper.style.gridTemplateRows = '0fr';
    if (mobileMenuIcon) {
      mobileMenuIcon.textContent = 'menu';
      mobileMenuIcon.style.transform = 'rotate(0deg)';
    }
    mobileLinks.forEach(function (link) {
      link.classList.remove('opacity-100', 'translate-x-0');
      link.classList.add('opacity-0', 'translate-x-[-20px]');
    });
  }

  function closeCart() {
    isCartOpen = false;
    if (cartWrapper) cartWrapper.style.gridTemplateRows = '0fr';
    document.querySelectorAll('.cart-item').forEach(function (item) {
      item.classList.remove('opacity-100', 'translate-x-0');
      item.classList.add('opacity-0', 'translate-x-[-20px]');
    });
  }

  function showEmptyCartToast() {
    var toast = document.getElementById('empty-cart-msg');
    if (!toast) return;
    toast.classList.remove('translate-y-[-150%]', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-[-150%]', 'opacity-0');
    }, 3000);
  }

  var lastCartClickTime = 0;
  function showSlowDownToast() {
    var toast = document.getElementById('cart-slow-down-msg');
    if (!toast) return;
    toast.classList.remove('translate-y-[-150%]', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-[-150%]', 'opacity-0');
    }, 2500);
  }

  // -----------------------------------------------
  // Shopify AJAX Cart API
  // -----------------------------------------------

  function formatMoney(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCartItems(items, skipAnimation) {
    if (!cartContainer) return;
    if (!items || items.length === 0) {
      cartContainer.innerHTML = '<div class="flex flex-col items-center justify-center py-10">'
        + '<span class="material-symbols-outlined text-[48px] text-slate-200 mb-2">shopping_cart</span>'
        + '<p class="text-slate-400 text-sm font-medium">Dein Warenkorb ist leer.</p>'
        + '</div>';
      return;
    }
    var html = '';
    var animClass = skipAnimation ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-[-20px]';
    items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="w-full h-full object-cover rounded-lg">'
        : '<span class="material-symbols-outlined text-slate-300 text-[28px]">image</span>';
      html += '<div class="cart-item ' + animClass + ' transition-all duration-300 flex items-center gap-3 py-3.5 border-b border-slate-200/50" data-unit-price="' + item.price + '" data-variant-id="' + item.variant_id + '">'
        + '<div class="w-14 h-14 rounded-lg flex items-center justify-center shrink-0 overflow-hidden">'
        + imgHtml
        + '</div>'
        + '<div class="flex-1 min-w-0">'
        + '<h5 class="font-headline font-bold text-sm text-on-surface line-clamp-1">' + item.product_title + '</h5>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="text-xs text-slate-400 mt-0.5">' + item.variant_title + '</p>' : '')
        + (fsIsFreeVariant(item.variant_id)
            ? '<p class="fs-cart-flag"><span class="material-symbols-outlined" aria-hidden="true">local_shipping</span>' + fsFreeLabel + '</p>'
            : '')
        + '<div class="flex justify-between items-center mt-1.5">'
        + '<span class="text-primary font-bold text-sm">' + formatMoney(item.final_line_price) + '</span>'
        + '<div class="flex items-center gap-2">'
        + '<button class="cart-minus w-7 h-7 flex items-center justify-center text-slate-400 hover:text-primary hover:bg-blue-50 rounded-lg transition-colors" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"><span class="material-symbols-outlined text-[16px]">remove</span></button>'
        + '<span class="text-xs font-bold w-5 text-center">' + item.quantity + '</span>'
        + '<button class="cart-plus w-7 h-7 flex items-center justify-center text-slate-400 hover:text-primary hover:bg-blue-50 rounded-lg transition-colors" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '"><span class="material-symbols-outlined text-[16px]">add</span></button>'
        + '<button class="cart-remove w-7 h-7 flex items-center justify-center text-slate-300 hover:text-red-400 rounded-lg transition-colors ml-2" data-key="' + item.key + '" data-qty="0" aria-label="Artikel entfernen"><span class="material-symbols-outlined text-[16px]">delete</span></button>'
        + '</div></div></div></div>';
    });
    cartContainer.innerHTML = html;

    cartContainer.querySelectorAll('.cart-minus, .cart-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var now = Date.now();
        if (now - lastCartClickTime < 600) {
          showSlowDownToast();
          return;
        }
        lastCartClickTime = now;
        var key        = this.getAttribute('data-key');
        var qty        = parseInt(this.getAttribute('data-qty'), 10);
        var isIncrease = this.classList.contains('cart-plus');
        var cartItem   = this.closest('.cart-item');
        var variantId  = cartItem ? parseInt(cartItem.getAttribute('data-variant-id'), 10) : null;
        changeCartItem(key, qty, variantId, isIncrease);
      });
    });

    cartContainer.querySelectorAll('.cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key      = this.getAttribute('data-key');
        var cartItem = this.closest('.cart-item');
        var variantId = cartItem ? parseInt(cartItem.getAttribute('data-variant-id'), 10) : null;
        changeCartItem(key, 0, variantId, false);
      });
    });
  }

  // --- Gratisversand-Fortschritt ---------------------------------
  // Liefert der Shop generell kostenlos (Theme-Einstellungen -> Versandkosten), gibt es
  // weder Leiste noch Fortschritt. Die Hinweise stehen dann fest im Liquid.
  var fsAll = !!(window.EkaCare && window.EkaCare.freeShippingAll);
  // Schwelle in Cent; unplausible Werte aus dem Theme-Editor fallen auf 44,95 € zurueck
  var fsThreshold = parseInt((window.EkaCare && window.EkaCare.freeShippingThreshold) || 0, 10);
  if (!fsThreshold || fsThreshold < 1) fsThreshold = 4495;
  var fsWasFree   = false;
  var fsMeter     = document.getElementById('fs-meter');
  var fsFill      = document.getElementById('fs-meter-fill');
  var fsText      = document.getElementById('fs-meter-text');
  var fsHint      = document.getElementById('fs-meter-hint');
  var fsSub       = document.getElementById('fs-meter-sub');
  var fsCelebTimer = null;
  var fsMoveTimer  = null;
  var fsLastPct    = null;

  // Die Leiste bekommt nur noch eine einzige Zahl; Fuellung und Punkt haengen im CSS
  // zusammen. Gleiche Werte werden verworfen, damit schnelles Klicken die laufende
  // Animation nicht staendig neu startet (das war das Ruckeln).
  function fsSetPct(pct) {
    if (!fsFill || !fsMeter) return;
    if (fsLastPct !== null && Math.abs(fsLastPct - pct) < 0.05) return;
    fsLastPct = pct;
    fsFill.style.setProperty('--fs-pct', pct.toFixed(1));
    fsMeter.classList.add('is-moving');
    clearTimeout(fsMoveTimer);
    fsMoveTimer = setTimeout(function () { fsMeter.classList.remove('is-moving'); }, 650);
  }

  // Werbetext in deutscher Schreibweise ("44,95 €"), passend zum Hero und zur Versandseite
  function fsMoney(cents) {
    var v = cents / 100;
    var txt = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    return txt + '\u00A0\u20AC';
  }

  if (fsHint) fsHint.textContent = 'ab ' + fsMoney(fsThreshold);

  // --- Gleiche Rechnung, zweite Anzeige: schmale Leiste auf der Produktseite ---
  var pdpShip      = document.getElementById('pdp-ship');
  var pdpShipFill  = document.getElementById('pdp-ship-fill');
  var pdpShipText  = document.getElementById('pdp-ship-text');
  var pdpWasFree   = null;
  var pdpCelebTimer = null;
  var pdpBumpTimer  = null;

  var pdpLastPct = null;

  function updatePdpShipping(totalCents) {
    if (fsAll) return;
    if (!pdpShip || !pdpShipFill || !pdpShipText) return;

    var missing = fsThreshold - totalCents;
    var isFree  = missing <= 0;
    var pct     = fsThreshold > 0 ? Math.min(100, (totalCents / fsThreshold) * 100) : 100;

    if (pdpLastPct === null || Math.abs(pdpLastPct - pct) >= 0.05) {
      pdpLastPct = pct;
      pdpShipFill.style.width = pct.toFixed(1) + '%';
    }

    if (isFree) {
      pdpShipText.innerHTML = '<strong>Kostenloser Versand</strong> \u2013 f\u00FCr diese Bestellung';
    } else if (totalCents === 0) {
      pdpShipText.innerHTML = 'Kostenloser Versand ab <strong>' + fsMoney(fsThreshold) + '</strong>';
    } else {
      pdpShipText.innerHTML = 'Noch <strong>' + fsMoney(missing) + '</strong> bis zum kostenlosen Versand';
    }

    pdpShip.classList.toggle('is-free', isFree);

    // Nur beim echten Überschreiten kurz feiern, nicht beim ersten Aufbau der Seite
    if (isFree && pdpWasFree === false) {
      pdpShip.classList.remove('is-celebrating');
      void pdpShip.offsetWidth;
      pdpShip.classList.add('is-celebrating');
      clearTimeout(pdpCelebTimer);
      pdpCelebTimer = setTimeout(function () { pdpShip.classList.remove('is-celebrating'); }, 1200);
    }
    pdpWasFree = isFree;
  }

  // Kurzer Schwung, wenn gerade etwas in den Warenkorb gelegt wurde
  function pdpShippingBump() {
    if (!pdpShip) return;
    pdpShip.classList.remove('is-bumping');
    void pdpShip.offsetWidth;
    pdpShip.classList.add('is-bumping');
    clearTimeout(pdpBumpTimer);
    pdpBumpTimer = setTimeout(function () { pdpShip.classList.remove('is-bumping'); }, 800);
  }

  // progressTotal = Summe, an der die Gratisgrenze gemessen wird (je nach Einstellung
  // die ganze Bestellsumme oder nur die kostenpflichtigen Artikel).
  // chargeCount = Anzahl der Artikel, fuer die ueberhaupt Versand anfaellt.
  // itemCount = alle Artikel im Warenkorb.
  function updateFreeShipping(progressTotal, chargeCount, itemCount) {
    if (fsAll) return;
    updatePdpShipping(progressTotal);
    if (!fsMeter || !fsFill || !fsText) return;

    // Leerer Warenkorb: nichts anzeigen
    if (!itemCount) {
      fsMeter.classList.add('is-hidden');
      fsMeter.classList.remove('is-allfree');
      fsWasFree = false;
      return;
    }
    fsMeter.classList.remove('is-hidden');

    var hasFreeItems = chargeCount < itemCount;
    var allFree      = chargeCount === 0;
    var missing      = fsThreshold - progressTotal;
    var isFree       = allFree || missing <= 0;
    var pct          = fsThreshold > 0 ? Math.min(100, (progressTotal / fsThreshold) * 100) : 100;

    fsMeter.classList.toggle('is-allfree', allFree);
    fsSetPct(allFree ? 100 : pct);

    if (allFree) {
      // Es gibt nichts mehr zu erreichen – also auch keine Fortschrittsleiste.
      fsText.innerHTML = '<strong>Versand geht auf uns.</strong> Diese Artikel liefern wir immer kostenlos.';
    } else if (isFree) {
      fsText.innerHTML = '<strong>Geschafft \u2013 Versand geht auf uns.</strong> Wir liefern kostenlos.';
    } else if (missing <= fsThreshold * 0.2) {
      fsText.innerHTML = 'Fast geschafft \u2013 nur noch <strong>' + fsMoney(missing) + '</strong> bis zum Gratisversand.';
    } else {
      fsText.innerHTML = 'Noch <strong>' + fsMoney(missing) + '</strong> bis zum kostenlosen Versand.';
    }

    // Gemischter Warenkorb: erklaeren, warum die Rechnung nicht zur Summe passt
    if (fsSub) {
      if (hasFreeItems && !allFree && !fsPromoCounts) {
        fsSub.textContent = 'Die versandkostenfreien Artikel sind hier schon abgezogen.';
        fsSub.classList.add('is-shown');
      } else {
        fsSub.textContent = '';
        fsSub.classList.remove('is-shown');
      }
    }

    fsMeter.classList.toggle('is-free', isFree);

    // Kurzer Impuls genau in dem Moment, in dem die Grenze ueberschritten wird
    if (isFree && !fsWasFree && !allFree) {
      fsMeter.classList.remove('is-celebrating');
      void fsMeter.offsetWidth;
      fsMeter.classList.add('is-celebrating');
      clearTimeout(fsCelebTimer);
      fsCelebTimer = setTimeout(function () { fsMeter.classList.remove('is-celebrating'); }, 1000);
    }
    fsWasFree = isFree;

    // Fussnote an der Gesamtsumme mitziehen
    var totalNote = document.getElementById('cart-total-note');
    if (totalNote) {
      totalNote.textContent = isFree ? 'Versand kostenlos \u00B7 ohne MwSt.' : 'zzgl. Versand \u00B7 ohne MwSt.';
    }
  }

  function updateCartHeader(cart) {
    var countText = document.getElementById('cart-count-text');
    var badge     = document.getElementById('cart-badge');
    var totalEl   = document.getElementById('cart-total-price');
    liveCartCount = cart.item_count;
    liveCartTotal = cart.total_price;

    // chargeCount/-Total = nur die Artikel, fuer die ueberhaupt Versand anfaellt
    liveChargeTotal = 0;
    liveChargeCount = 0;
    (cart.items || []).forEach(function (item) {
      if (fsIsFreeVariant(item.variant_id)) return;
      liveChargeTotal += item.final_line_price;
      liveChargeCount += item.quantity;
    });
    liveProgressTotal = fsPromoCounts ? liveCartTotal : liveChargeTotal;

    if (countText) countText.innerText = liveCartCount;
    if (badge)     badge.innerText = liveCartCount;
    if (totalEl)   totalEl.innerText = formatMoney(liveCartTotal);
    updateFreeShipping(liveProgressTotal, liveChargeCount, liveCartCount);
    try { localStorage.setItem('eka_cart_count', liveCartCount); } catch(e) {}
  }

  function updateCartHeaderOptimistic(countDelta, priceDelta, variantId) {
    liveCartCount = Math.max(0, liveCartCount + countDelta);
    liveCartTotal = Math.max(0, liveCartTotal + priceDelta);
    if (!fsIsFreeVariant(variantId)) {
      liveChargeCount = Math.max(0, liveChargeCount + countDelta);
      liveChargeTotal = Math.max(0, liveChargeTotal + priceDelta);
    }
    liveProgressTotal = fsPromoCounts ? liveCartTotal : liveChargeTotal;
    var countText = document.getElementById('cart-count-text');
    var badge     = document.getElementById('cart-badge');
    var totalEl   = document.getElementById('cart-total-price');
    if (countText) countText.innerText = liveCartCount;
    if (badge)     badge.innerText = liveCartCount;
    if (totalEl)   totalEl.innerText = formatMoney(liveCartTotal);
    updateFreeShipping(liveProgressTotal, liveChargeCount, liveCartCount);
    try { localStorage.setItem('eka_cart_count', liveCartCount); } catch(e) {}
  }

  // Badge sofort mit gespeicherter Zahl füllen (vor API-Call)
  try {
    var savedCount = localStorage.getItem('eka_cart_count');
    if (savedCount !== null) {
      var badge = document.getElementById('cart-badge');
      var countText = document.getElementById('cart-count-text');
      if (badge) badge.innerText = savedCount;
      if (countText) countText.innerText = savedCount;
    }
  } catch(e) {}

  function fetchCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartHeader(cart);
        if (callback) callback(cart);
      });
  }

  function addToCart(variantId, qty, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      var cartIcon = document.getElementById('cart-icon');
      if (cartIcon) {
        cartIcon.classList.add('cart-bounce');
        setTimeout(function () { cartIcon.classList.remove('cart-bounce'); }, 300);
      }
      fetchCart(function (cart) {
        renderCartItems(cart.items, true);
        pdpShippingBump();
      });
    })
    .catch(function () {
      showEmptyCartToast();
    })
    .finally(function () {
      if (btn) btn.disabled = false;
    });
  }

  function syncCartFromServer(cart) {
    if (!cart || cart.item_count === undefined) return;
    updateCartHeader(cart);
    if (cart.item_count === 0) {
      renderCartItems(cart.items, true);
      closeCart();
    }
  }

  function changeCartItem(key, qty, variantId, isIncrease) {
    // Optimistisches UI-Update
    var items = cartContainer.querySelectorAll('.cart-item');
    items.forEach(function (item) {
      var minusBtn = item.querySelector('.cart-minus');
      if (minusBtn && minusBtn.getAttribute('data-key') === key) {
        var unitPrice = parseInt(item.getAttribute('data-unit-price') || '0', 10);
        var prevQty    = parseInt(minusBtn.getAttribute('data-qty'), 10) + 1;
        var qtyDelta   = qty - prevQty;
        if (qty <= 0) {
          item.style.transition = 'opacity 0.2s, transform 0.2s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(-20px)';
          setTimeout(function () { item.remove(); }, 200);
          updateCartHeaderOptimistic(-prevQty, -(unitPrice * prevQty), variantId);
        } else {
          var qtySpan = item.querySelector('.text-xs.font-bold.w-5');
          if (qtySpan) qtySpan.textContent = qty;
          var priceSpan = item.querySelector('.text-primary.font-bold.text-sm');
          if (priceSpan && unitPrice > 0) priceSpan.textContent = formatMoney(unitPrice * qty);
          minusBtn.setAttribute('data-qty', qty - 1);
          var plusBtn = item.querySelector('.cart-plus');
          if (plusBtn) plusBtn.setAttribute('data-qty', qty + 1);
          updateCartHeaderOptimistic(qtyDelta, unitPrice * qtyDelta, variantId);
        }
      }
    });

    if (isIncrease) {
      // + Klick: /cart/add.js (identisch mit "In den Warenkorb" – funktioniert garantiert)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(syncCartFromServer); });
    } else {
      // - Klick oder Entfernen: /cart/change.js mit absoluter Menge
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncCartFromServer(cart);
        if (qty <= 0) renderCartItems(cart.items, true);
      });
    }
  }

  function animateCartItemsIn() {
    document.querySelectorAll('.cart-item').forEach(function (item, index) {
      setTimeout(function () {
        item.classList.remove('opacity-0', 'translate-x-[-20px]');
        item.classList.add('opacity-100', 'translate-x-0');
      }, 50 + (index * 60));
    });
  }

  // Seite laden: aktuellen Warenkorbstand abrufen
  fetchCart(function (cart) {
    renderCartItems(cart.items);
  });

  // Add-to-Cart Buttons auf Produktkarten
  function attachAddToCartListeners() {
    document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
      if (btn._addToCartBound) return;
      btn._addToCartBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;
        addToCart(variantId, 1, this);
      });
    });
  }
  attachAddToCartListeners();

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function () {
      if (isCartOpen) closeCart();
      isMenuOpen = !isMenuOpen;
      if (isMenuOpen) {
        mobileMenuWrapper.style.gridTemplateRows = '1fr';
        mobileMenuIcon.textContent = 'close';
        mobileMenuIcon.style.transform = 'rotate(90deg)';
        mobileLinks.forEach(function (link, index) {
          setTimeout(function () {
            link.classList.remove('opacity-0', 'translate-x-[-20px]');
            link.classList.add('opacity-100', 'translate-x-0');
          }, 150 + (index * 100));
        });
      } else {
        closeMenu();
      }
    });
  }

  if (cartToggleBtn) {
    cartToggleBtn.addEventListener('click', function () {
      if (isMenuOpen) closeMenu();
      isCartOpen = !isCartOpen;
      if (isCartOpen) {
        fetchCart(function (cart) {
          if (cart.item_count === 0) {
            showEmptyCartToast();
            isCartOpen = false;
            return;
          }
          renderCartItems(cart.items);
          if (cartWrapper) cartWrapper.style.gridTemplateRows = '1fr';
          animateCartItemsIn();
        });
      } else {
        closeCart();
      }
    });
  }

  // -----------------------------------------------
  // 4. FAQ Accordion
  // -----------------------------------------------
  document.querySelectorAll('.faq-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var currentContent = button.nextElementSibling;
      var currentIcon    = button.querySelector('.faq-icon');
      var isOpen         = currentContent.classList.contains('open');

      document.querySelectorAll('.faq-content').forEach(function (c) { c.classList.remove('open'); });
      document.querySelectorAll('.faq-icon').forEach(function (icon) {
        icon.style.transform = 'rotate(0deg)';
        icon.textContent = 'add_circle';
        icon.classList.remove('text-primary');
        icon.classList.add('text-slate-400');
      });
      document.querySelectorAll('.faq-button').forEach(function (btn) { btn.classList.remove('text-primary'); });

      if (!isOpen) {
        currentContent.classList.add('open');
        currentIcon.style.transform = 'rotate(180deg)';
        currentIcon.textContent = 'remove_circle';
        currentIcon.classList.remove('text-slate-400');
        currentIcon.classList.add('text-primary');
        button.classList.add('text-primary');
      }
    });
  });

  // -----------------------------------------------
  // 5. Lazy Load GIF – play once & freeze at last frame
  // -----------------------------------------------
  var gifTriggers = document.querySelectorAll('.gif-trigger');
  var gifObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var img = entry.target;
        var gifSrc = img.getAttribute('data-gif-src');
        if (!gifSrc) return;

        // Load GIF as blob so we can draw it on canvas (same-origin)
        fetch(gifSrc)
          .then(function (r) { return r.blob(); })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            img.src = blobUrl;

            // Continuously capture current frame; after GIF ends, canvas keeps last frame
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var captureInterval = setInterval(function () {
              if (img.naturalWidth > 0) {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
              }
            }, 100);

            // After 6 seconds, freeze at whatever frame was last captured
            setTimeout(function () {
              clearInterval(captureInterval);
              // One final capture
              if (img.naturalWidth > 0) {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
              }
              try {
                var dataUrl = canvas.toDataURL('image/png');
                img.src = dataUrl;
              } catch (e) {
                // Fallback: leave the GIF running
              }
              URL.revokeObjectURL(blobUrl);
            }, 6000);
          })
          .catch(function () {
            // Fallback: just load the GIF normally
            img.src = gifSrc;
          });

        observer.unobserve(img);
      }
    });
  }, { root: null, threshold: 0.5 });
  gifTriggers.forEach(function (gif) { gifObserver.observe(gif); });

  // -----------------------------------------------
  // 6. Shop – Category & Sort Dropdowns
  // -----------------------------------------------
  function initDropdown(btnId, menuId, arrowId, textId, onChange) {
    var btn   = document.getElementById(btnId);
    var menu  = document.getElementById(menuId);
    var arrow = document.getElementById(arrowId);
    var text  = document.getElementById(textId);
    if (!btn || !menu) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = menu.classList.contains('open');
      document.querySelectorAll('.dropdown-menu').forEach(function (m) { m.classList.remove('open'); m.classList.add('hidden'); });
      if (!isOpen) {
        menu.classList.remove('hidden');
        requestAnimationFrame(function () { menu.classList.add('open'); });
        if (arrow) arrow.style.transform = 'rotate(180deg)';
      } else {
        if (arrow) arrow.style.transform = 'rotate(0deg)';
      }
    });

    menu.querySelectorAll('li').forEach(function (li) {
      li.addEventListener('click', function () {
        var value = this.getAttribute('data-filter') || this.textContent.trim();
        if (text) text.textContent = this.textContent.trim();
        menu.querySelectorAll('.material-symbols-outlined').forEach(function (ic) { ic.classList.add('opacity-0'); });
        var check = this.querySelector('.material-symbols-outlined');
        if (check) check.classList.remove('opacity-0');
        menu.classList.remove('open');
        menu.classList.add('hidden');
        if (arrow) arrow.style.transform = 'rotate(0deg)';
        if (onChange) onChange(value);
      });
    });
  }

  // Category dropdown – AJAX: lädt Kollektion ohne Seiten-Reload
  initDropdown('category-dropdown-btn', 'category-dropdown-menu', 'dropdown-arrow', 'selected-category-text', null);

  function attachCategoryAjaxListeners() {
    var categoryMenu = document.getElementById('category-dropdown-menu');
    if (!categoryMenu) return;
    categoryMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = this.getAttribute('href');
        if (!url) return;
        var grid = document.getElementById('product-grid-container');
        var countEl = document.getElementById('product-count');
        if (!grid) { window.location.href = url; return; }

        grid.style.opacity = '0.4';
        grid.style.pointerEvents = 'none';

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid-container');
            if (newGrid) {
              grid.innerHTML = newGrid.innerHTML;
              attachAddToCartListeners();
            }
            var newCount = doc.getElementById('product-count');
            if (newCount && countEl) countEl.textContent = newCount.textContent;
            // Dropdown-Menü mit neuen Haken aus der geholten Seite aktualisieren
            var newCatMenu = doc.getElementById('category-dropdown-menu');
            var currentCatMenu = document.getElementById('category-dropdown-menu');
            if (newCatMenu && currentCatMenu) {
              currentCatMenu.innerHTML = newCatMenu.innerHTML;
              attachCategoryAjaxListeners();
            }
            // Dropdown-Label aktualisieren
            var labelEl = document.getElementById('selected-category-text');
            if (labelEl) labelEl.textContent = this.textContent.trim();
            grid.style.opacity = '1';
            grid.style.pointerEvents = '';
            history.pushState(null, '', url);
          }.bind(this))
          .catch(function () {
            grid.style.opacity = '1';
            grid.style.pointerEvents = '';
            window.location.href = url;
          });
      });
    });
  }
  attachCategoryAjaxListeners();

  // Sort-Option aktiv markieren
  function updateActiveSortOption(sortByValue) {
    document.querySelectorAll('.sort-option[data-sort-by]').forEach(function (opt) {
      var isActive = opt.getAttribute('data-sort-by') === sortByValue;
      opt.classList.toggle('text-primary', isActive);
      opt.classList.toggle('font-bold', isActive);
      opt.classList.toggle('text-slate-600', !isActive);
      opt.classList.toggle('font-medium', !isActive);
    });
  }

  // Beim Seitenload aktive Sort-Option aus URL lesen
  (function () {
    var params = new URLSearchParams(window.location.search);
    var currentSort = params.get('sort_by') || 'manual';
    var knownSorts = ['manual', 'price-ascending', 'price-descending', 'created-descending'];
    if (knownSorts.indexOf(currentSort) === -1) currentSort = 'manual';
    updateActiveSortOption(currentSort);
    var sortLabelEl = document.getElementById('selected-sort-text');
    if (sortLabelEl) {
      var activeOpt = document.querySelector('.sort-option[data-sort-by="' + currentSort + '"]');
      if (activeOpt) sortLabelEl.textContent = activeOpt.textContent.trim();
    }
  })();

  // Sort dropdown – AJAX: lädt sortierte Produkte ohne Seiten-Reload
  initDropdown('sort-dropdown-btn', 'sort-dropdown-menu', 'sort-dropdown-arrow', 'selected-sort-text', function (value) {
    var sortOptions = document.querySelectorAll('.sort-option[data-sort-by]');
    var sortByValue = 'manual';
    sortOptions.forEach(function (opt) {
      if (opt.textContent.trim() === value) {
        sortByValue = opt.getAttribute('data-sort-by');
      }
    });
    updateActiveSortOption(sortByValue);

    var url = window.location.pathname + '?sort_by=' + sortByValue;
    var grid = document.getElementById('product-grid-container');
    var countEl = document.getElementById('product-count');
    if (!grid) return;

    // Ladeindikator
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid-container');
        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
          // Re-attach add-to-cart listeners for new grid items
          attachAddToCartListeners();
        }
        var newCount = doc.getElementById('product-count');
        if (newCount && countEl) {
          countEl.textContent = newCount.textContent;
        }
        grid.style.opacity = '1';
        grid.style.pointerEvents = '';
        history.pushState(null, '', url);
      })
      .catch(function () {
        grid.style.opacity = '1';
        grid.style.pointerEvents = '';
      });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function () {
    document.querySelectorAll('.dropdown-menu').forEach(function (m) {
      m.classList.remove('open');
      m.classList.add('hidden');
    });
    document.querySelectorAll('#dropdown-arrow, #sort-dropdown-arrow').forEach(function (a) {
      a.style.transform = 'rotate(0deg)';
    });
  });

  // -----------------------------------------------
  // 6b. Shop – Live-Suche
  // -----------------------------------------------
  var shopSearchInput = document.getElementById('shop-search-input');
  if (shopSearchInput) {
    shopSearchInput.addEventListener('input', function () {
      var term = this.value.toLowerCase().trim();
      var cards = document.querySelectorAll('#product-grid-container .product-item');
      var noResults = document.getElementById('shop-no-results');
      var gridWrapper = document.getElementById('product-grid-wrapper');
      var visible = 0;
      cards.forEach(function (card) {
        var title = card.getAttribute('data-title') || '';
        var match = !term || title.indexOf(term) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      var countEl = document.getElementById('product-count');
      if (countEl) countEl.textContent = visible;
      if (noResults) noResults.classList.toggle('hidden', visible > 0);
      if (gridWrapper) gridWrapper.classList.toggle('hidden', visible === 0);
    });
  }

  // -----------------------------------------------
  // 7. Product Detail Page – Image Gallery (Swipe + Thumbnails)
  // -----------------------------------------------

  // Ladezustand der Produktbilder: Schimmern + Spinner, bis das Bild wirklich da ist.
  // Vorher blieb die Flaeche beim schnellen Durchklicken einfach leer.
  function pdpMarkLoaded(img) {
    img.classList.add('is-loaded');
    var slide = img.parentElement;
    var loader = slide ? slide.querySelector('.pdp-loader') : null;
    if (loader) {
      loader.classList.add('is-done');
      // Erst nach dem Ausblenden aus dem Weg raeumen
      setTimeout(function () {
        if (loader.classList.contains('is-done')) loader.style.display = 'none';
      }, 400);
    }
  }

  function pdpWatchImages(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.pdp-slide-img'), function (img) {
      if (img._pdpWatched) return;
      img._pdpWatched = true;
      if (img.complete && img.naturalWidth > 0) {
        pdpMarkLoaded(img);
        return;
      }
      img.addEventListener('load', function () { pdpMarkLoaded(img); });
      img.addEventListener('error', function () {
        // Kaputtes Bild: Spinner weg, sonst dreht er sich endlos
        pdpMarkLoaded(img);
      });
    });
  }
  pdpWatchImages(document);

  // Nachbarbilder vorziehen, damit der naechste Klick meist sofort sitzt
  function pdpPreloadAround(index) {
    var imgs = document.querySelectorAll('#pdp-slides .pdp-slide-img');
    [index - 1, index + 1, index + 2].forEach(function (i) {
      if (i < 0 || i >= imgs.length) return;
      var img = imgs[i];
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    });
  }

  var slidesEl   = document.getElementById('pdp-slides');
  var counterEl  = document.getElementById('pdp-slide-counter');
  var thumbArr   = Array.from(document.querySelectorAll('.pdp-thumb'));
  var slideCount = thumbArr.length;
  var mainImg    = null; // kein einzelnes mainImg mehr – Slides-Container übernimmt
  var pdpActive  = 0;

  function pdpUpdateUI(index) {
    pdpActive = index;
    if (counterEl) counterEl.textContent = (index + 1) + ' / ' + slideCount;
    thumbArr.forEach(function (t, i) {
      if (i === index) {
        t.classList.remove('border-slate-200', 'border');
        t.classList.add('border-primary', 'border-2');
        t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        t.classList.remove('border-primary', 'border-2');
        t.classList.add('border-slate-200', 'border');
      }
    });
  }

  function pdpGoToSlide(index) {
    if (!slidesEl || index < 0 || index >= slideCount) return;
    pdpPreloadAround(index);
    slidesEl.scrollTo({ left: index * slidesEl.offsetWidth, behavior: 'smooth' });
    pdpUpdateUI(index);
  }

  // Thumbnail-Klick → Slide wechseln
  thumbArr.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { pdpGoToSlide(i); });
  });

  // User swipet → Counter + Thumbnails sofort, scrollIntoView debounced
  if (slidesEl) {
    var pdpScrollTimer;
    slidesEl.addEventListener('scroll', function () {
      var w = slidesEl.offsetWidth;
      if (!w) return;
      var idx = Math.round(slidesEl.scrollLeft / w);

      // Counter + Thumbnail-Border: sofort
      if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + slideCount;
      if (idx !== pdpActive) {
        pdpActive = idx;
        pdpPreloadAround(idx);
        thumbArr.forEach(function (t, i) {
          if (i === idx) {
            t.classList.remove('border-slate-200', 'border');
            t.classList.add('border-primary', 'border-2');
          } else {
            t.classList.remove('border-primary', 'border-2');
            t.classList.add('border-slate-200', 'border');
          }
        });
      }

      // Thumbnail-Strip scrollen: debounced (verhindert Konflikt mit Haupt-Swipe)
      clearTimeout(pdpScrollTimer);
      pdpScrollTimer = setTimeout(function () {
        var active = thumbArr[pdpActive];
        if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }, 120);
    });
  }

  // -----------------------------------------------
  // 7b. Product Detail Page – Lightbox (Großansicht + Swipe + Arrows + Keyboard)
  // -----------------------------------------------
  var lightboxEl      = document.getElementById('pdp-lightbox');
  var lightboxSlides  = document.getElementById('pdp-lightbox-slides');
  var lightboxCounter = document.getElementById('pdp-lightbox-counter');
  var lightboxClose   = document.getElementById('pdp-lightbox-close');
  var lightboxPrev    = document.getElementById('pdp-lightbox-prev');
  var lightboxNext    = document.getElementById('pdp-lightbox-next');
  var lightboxBackdrop = document.getElementById('pdp-lightbox-backdrop');

  if (lightboxEl && lightboxSlides && slidesEl) {
    var lightboxCount   = lightboxSlides.children.length;
    var lightboxActive  = 0;
    var lightboxTrigger = null;

    function lightboxUpdateCounter(index) {
      lightboxActive = index;
      if (lightboxCounter) lightboxCounter.textContent = (index + 1) + ' / ' + lightboxCount;
    }

    function lightboxGoTo(index, smooth) {
      if (index < 0 || index >= lightboxCount) return;
      lightboxSlides.scrollTo({
        left: index * lightboxSlides.offsetWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });
      lightboxUpdateCounter(index);
    }

    function openLightbox(startIndex) {
      lightboxTrigger = document.activeElement;
      document.body.style.overflow = 'hidden';
      lightboxEl.classList.add('is-open');
      lightboxEl.setAttribute('aria-hidden', 'false');
      // Erst sichtbar machen, dann ohne Animation zum Start-Slide springen
      requestAnimationFrame(function () {
        lightboxGoTo(startIndex || 0, false);
        if (lightboxClose) lightboxClose.focus();
      });
    }

    function closeLightbox() {
      lightboxEl.classList.remove('is-open');
      lightboxEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Fokus zurück auf das auslösende Bild / Slide-Container
      if (lightboxTrigger && typeof lightboxTrigger.focus === 'function') {
        lightboxTrigger.focus();
      }
    }

    // Klick auf Hauptbild → Lightbox öffnen
    slidesEl.addEventListener('click', function () {
      openLightbox(pdpActive);
    });

    // Schließen: X-Button, Backdrop, Escape
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);

    // Klick auf Slide-Container ausserhalb des Bildes schliesst ebenfalls
    lightboxSlides.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') closeLightbox();
    });

    // Arrow-Buttons
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () {
      lightboxGoTo(lightboxActive - 1, true);
    });
    if (lightboxNext) lightboxNext.addEventListener('click', function () {
      lightboxGoTo(lightboxActive + 1, true);
    });

    // Swipe/Scroll-Sync: Counter aktualisieren
    var lightboxScrollTimer;
    lightboxSlides.addEventListener('scroll', function () {
      clearTimeout(lightboxScrollTimer);
      lightboxScrollTimer = setTimeout(function () {
        var w = lightboxSlides.offsetWidth;
        if (!w) return;
        var idx = Math.round(lightboxSlides.scrollLeft / w);
        if (idx !== lightboxActive) lightboxUpdateCounter(idx);
      }, 60);
    });

    // Tastatur: Escape schließt, ←/→ wechselt (nur wenn offen)
    document.addEventListener('keydown', function (e) {
      if (!lightboxEl.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        lightboxGoTo(lightboxActive - 1, true);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        lightboxGoTo(lightboxActive + 1, true);
      }
    });

    // Resize: aktiven Slide neu anscrollen, um Misalignment zu verhindern
    window.addEventListener('resize', function () {
      if (!lightboxEl.classList.contains('is-open')) return;
      lightboxGoTo(lightboxActive, false);
    });
  }

  // -----------------------------------------------
  // 8. Formulare – Spam-Falle (Honeypot)
  // Versand laeuft ueber Shopifys eigenes Kontaktformular (kein Drittanbieter).
  // Ohne JS wird das Formular trotzdem normal abgeschickt.
  // -----------------------------------------------
  Array.prototype.forEach.call(
    document.querySelectorAll('form[action$="/contact"], form[action*="/contact#"]'),
    function (frm) {
      frm.addEventListener('submit', function (e) {
        var trap = frm.querySelector('.cf-trap input');
        if (trap && trap.value.trim() !== '') e.preventDefault();
      });
    }
  );

  // Quantity selector on PDP
  var qtyInput = document.getElementById('pdp-qty');
  var qtyMinus = document.getElementById('pdp-qty-minus');
  var qtyPlus  = document.getElementById('pdp-qty-plus');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var v   = parseInt(qtyInput.value, 10);
      var max = qtyInput.max !== '' ? parseInt(qtyInput.max, 10) : Infinity;
      if (v < max) qtyInput.value = v + 1;
    });
  }

  // Add-to-cart on PDP – Shopify AJAX
  var pdpCartBtn = document.getElementById('pdp-add-to-cart');
  if (pdpCartBtn) {
    pdpCartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      addToCart(variantId, qty, this);
    });
  }

  // Multi-Option Varianten-Auswahl auf PDP (Größe, Modell, Farbe …)
  var productVariantsEl = document.getElementById('product-variants-json');
  if (productVariantsEl && pdpCartBtn) {
    var allVariants    = JSON.parse(productVariantsEl.textContent);
    var optSelectors   = document.querySelectorAll('.option-selector');
    var selectedOpts   = {};

    // Initiale Auswahl aus dem Markup lesen (erste Buttons)
    optSelectors.forEach(function (sel) {
      var idx  = sel.getAttribute('data-option-index');
      var first = sel.querySelector('.option-btn[aria-pressed="true"]');
      if (first) selectedOpts[idx] = first.getAttribute('data-option-value');
    });

    function findVariant() {
      return allVariants.find(function (v) {
        return Object.keys(selectedOpts).every(function (idx) {
          return v['option' + (parseInt(idx, 10) + 1)] === selectedOpts[idx];
        });
      }) || null;
    }

    var allPrices = (function () {
      var el = document.getElementById('product-prices-json');
      return el ? JSON.parse(el.textContent) : {};
    }());

    var stockStatusEl  = document.getElementById('pdp-stock-status');
    var soldOutBtn     = document.getElementById('pdp-sold-out-btn');
    var buyNowWrapper  = document.getElementById('pdp-buy-now-wrapper');

    var STOCK_IN  = '<span class="relative flex h-3 w-3"><span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span><span class="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span></span><span class="text-sm font-bold text-green-600 tracking-wide">Auf Lager</span>';
    var STOCK_OUT = '<span class="relative flex h-3 w-3"><span class="relative inline-flex rounded-full h-3 w-3 bg-red-400"></span></span><span class="text-sm font-bold text-red-500 tracking-wide">Ausverkauft</span>';

    function applyVariant(variant) {
      var priceEl      = document.getElementById('pdp-price');
      var compareEl    = document.getElementById('pdp-compare-price');
      var saveBadge    = document.getElementById('pdp-save-badge');
      var buyNowInput  = document.getElementById('pdp-buy-now-variant-id');
      var available    = variant ? variant.available : false;

      // Add-to-Cart / Ausverkauft-Button tauschen
      if (available) {
        pdpCartBtn.classList.remove('hidden');
        if (soldOutBtn)    soldOutBtn.classList.add('hidden');
        if (buyNowWrapper) buyNowWrapper.classList.remove('hidden');
      } else {
        pdpCartBtn.classList.add('hidden');
        if (soldOutBtn)    soldOutBtn.classList.remove('hidden');
        if (buyNowWrapper) buyNowWrapper.classList.add('hidden');
      }

      // Lagerstatus-Anzeige
      if (stockStatusEl) stockStatusEl.innerHTML = available ? STOCK_IN : STOCK_OUT;

      if (variant) {
        pdpCartBtn.setAttribute('data-variant-id', String(variant.id));
        if (buyNowInput) buyNowInput.value = variant.id;

        // Maximale Menge anhand des Lagerbestands begrenzen
        if (qtyInput) {
          var tracked = variant.inventory_management === 'shopify';
          var deny    = variant.inventory_policy === 'deny';
          var stock   = variant.inventory_quantity;
          if (tracked && deny && typeof stock === 'number' && stock > 0) {
            qtyInput.max = stock;
            if (parseInt(qtyInput.value, 10) > stock) qtyInput.value = stock;
          } else {
            qtyInput.removeAttribute('max');
          }
        }

        // Preis aktualisieren
        var pd = allPrices[variant.id];
        if (pd && priceEl) {
          priceEl.textContent = pd.price;
          if (pd.has_compare) {
            if (compareEl) { compareEl.textContent = pd.compare_at_price; compareEl.classList.remove('hidden'); }
            if (saveBadge) { saveBadge.textContent = '-' + pd.save_percent + '%'; saveBadge.classList.remove('hidden'); }
            priceEl.classList.remove('text-on-surface'); priceEl.classList.add('text-primary');
          } else {
            if (compareEl) compareEl.classList.add('hidden');
            if (saveBadge) saveBadge.classList.add('hidden');
            priceEl.classList.remove('text-primary'); priceEl.classList.add('text-on-surface');
          }
        }

        // Varianten-Bild wechseln → zum passenden Slide scrollen
        // Weg 1: Bild direkt der Variante zugewiesen (Shopify Admin → Variante → Bild)
        if (variant.featured_image) {
          var imgId      = String(variant.featured_image.id);
          var matchThumb = document.querySelector('.pdp-thumb[data-image-id="' + imgId + '"]');
          if (matchThumb) {
            var matchIdx = thumbArr.indexOf(matchThumb);
            if (matchIdx >= 0) { pdpGoToSlide(matchIdx); }
          }
        } else {
          // Weg 2: Bild-Alt-Text stimmt mit einem Optionswert überein
          // (Admin → Produkt → Bild bearbeiten → Alt-Text = z.B. "Modell A")
          var optVals = [variant.option1, variant.option2, variant.option3]
            .filter(Boolean)
            .map(function (v) { return v.toLowerCase().trim(); });
          if (optVals.length) {
            var altIdx = thumbArr.findIndex(function (t) {
              var alt = t.getAttribute('data-alt') || '';
              return alt && optVals.indexOf(alt) >= 0;
            });
            if (altIdx >= 0) pdpGoToSlide(altIdx);
          }
        }
      }
    }

    // Nicht-verfügbare Optionswerte ausgegraut markieren
    function updateOptionAvailability() {
      optSelectors.forEach(function (sel) {
        var idx = sel.getAttribute('data-option-index');
        sel.querySelectorAll('.option-btn').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var hasAvailable = allVariants.some(function (v) {
            if (!v.available) return false;
            // Prüfen ob diese Option + alle anderen ausgewählten Optionen → verfügbare Variante
            return v['option' + (parseInt(idx, 10) + 1)] === val &&
              Object.keys(selectedOpts).every(function (otherIdx) {
                if (otherIdx === idx) return true;
                return v['option' + (parseInt(otherIdx, 10) + 1)] === selectedOpts[otherIdx];
              });
          });
          if (hasAvailable) {
            btn.disabled = false;
            btn.classList.remove('opacity-40', 'line-through', 'cursor-not-allowed');
          } else {
            btn.disabled = true;
            btn.classList.add('opacity-40', 'line-through', 'cursor-not-allowed');
          }
        });
      });
    }

    optSelectors.forEach(function (sel) {
      sel.querySelectorAll('.option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = this.getAttribute('data-option-index');
          var val = this.getAttribute('data-option-value');

          // Buttons dieser Gruppe zurücksetzen
          sel.querySelectorAll('.option-btn').forEach(function (b) {
            b.classList.remove('border-[#111827]', 'bg-[#111827]', 'text-white');
            b.classList.add('border-slate-200', 'text-on-surface');
            b.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('border-[#111827]', 'bg-[#111827]', 'text-white');
          this.classList.remove('border-slate-200', 'text-on-surface');
          this.setAttribute('aria-pressed', 'true');

          selectedOpts[idx] = val;
          updateOptionAvailability();
          applyVariant(findVariant());
        });
      });
    });

    // Initiales Update
    updateOptionAvailability();
    applyVariant(findVariant());
  }

  // -----------------------------------------------
  // 9. Native Carousel Logic (Empfehlungen)
  // -----------------------------------------------
  var carousel = document.getElementById('native-carousel');

  if (carousel) {
    var isCarouselInitialized = false;
    var carouselCards = [];
    var originalCardCount = carousel.querySelectorAll('.carousel-card').length;

    var updateCenterCard = function () {
      if (carousel.offsetWidth === 0) return;
      var containerCenter = carousel.scrollLeft + (carousel.clientWidth / 2);

      var closestCard = null;
      var minDistance = Infinity;

      carouselCards.forEach(function (card) {
        var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        var distance = Math.abs(containerCenter - cardCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      carouselCards.forEach(function (card) {
        if (card === closestCard) {
          if (!card.classList.contains('is-center')) {
            card.classList.add('is-center');
            var btn = card.querySelector('span.mt-auto');
            if (btn) {
              btn.classList.remove('bg-slate-50', 'text-slate-700');
              btn.classList.add('bg-primary', 'text-white', 'shadow-md');
            }
          }
        } else {
          if (card.classList.contains('is-center')) {
            card.classList.remove('is-center');
            var btn = card.querySelector('span.mt-auto');
            if (btn) {
              btn.classList.add('bg-slate-50', 'text-slate-700');
              btn.classList.remove('bg-primary', 'text-white', 'shadow-md');
            }
          }
        }
      });
    };

    var initCarousel = function () {
      if (window.innerWidth >= 1024) return;
      if (isCarouselInitialized) return;
      if (originalCardCount === 0) return;

      var originalCardsHTML = carousel.innerHTML;
      carousel.innerHTML = originalCardsHTML.repeat(12);
      carouselCards = Array.from(carousel.querySelectorAll('.carousel-card'));

      setTimeout(function () {
        var startCard = carouselCards[Math.floor(carouselCards.length / 2)];
        if (startCard) {
          carousel.scrollLeft = startCard.offsetLeft - (carousel.clientWidth / 2) + (startCard.offsetWidth / 2);
          updateCenterCard();
        }
      }, 50);

      isCarouselInitialized = true;
    };

    initCarousel();
    window.addEventListener('resize', function () {
      if (window.innerWidth < 1024) {
        initCarousel();
      }
    });

    var isScrollingTimeout;
    carousel.addEventListener('scroll', function () {
      if (window.innerWidth >= 1024) return;

      requestAnimationFrame(updateCenterCard);

      window.clearTimeout(isScrollingTimeout);
      isScrollingTimeout = setTimeout(function () {
        if (carousel.scrollLeft < 500 || carousel.scrollLeft > (carousel.scrollWidth - carousel.clientWidth - 500)) {
          var containerCenter = carousel.scrollLeft + (carousel.clientWidth / 2);
          var activeCard = carouselCards[0];
          var minDist = Infinity;
          carouselCards.forEach(function (card) {
            var dist = Math.abs((card.offsetLeft + card.offsetWidth / 2) - containerCenter);
            if (dist < minDist) { minDist = dist; activeCard = card; }
          });

          if (activeCard) {
            var cardIndexInOriginal = Array.from(carouselCards).indexOf(activeCard) % originalCardCount;
            var middleSetStartIndex = Math.floor(carouselCards.length / 2) - Math.floor(originalCardCount / 2);
            var newTargetCard = carouselCards[middleSetStartIndex + cardIndexInOriginal];

            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = newTargetCard.offsetLeft - (carousel.clientWidth / 2) + (newTargetCard.offsetWidth / 2);

            setTimeout(function () { carousel.style.scrollBehavior = 'smooth'; }, 50);
          }
        }
      }, 150);
    });
  }

  // -----------------------------------------------
  // 10. Cookie Consent Banner (DSGVO)
  // -----------------------------------------------
  var cookieBanner = document.getElementById('cookie-banner');

  if (cookieBanner) {
    var acceptAllBtn     = document.getElementById('cookie-accept-all');
    var essentialOnlyBtn = document.getElementById('cookie-essential-only');
    var settingsBtn      = document.getElementById('cookie-settings-btn');
    var saveSettingsBtn  = document.getElementById('cookie-save-settings');
    var detailsPanel     = document.getElementById('cookie-details');
    var marketingToggle  = document.getElementById('cookie-marketing-toggle');
    var footerCookieBtn  = document.getElementById('footer-cookie-settings');

    function getCookieConsent() {
      try {
        var val = localStorage.getItem('eka_cookie_consent');
        return val ? JSON.parse(val) : null;
      } catch (e) { return null; }
    }

    function setCookieConsent(consent) {
      consent.timestamp = new Date().toISOString();
      localStorage.setItem('eka_cookie_consent', JSON.stringify(consent));
    }

    function showBanner() {
      cookieBanner.classList.remove('translate-y-full', 'opacity-0', 'pointer-events-none');
      cookieBanner.classList.add('translate-y-0', 'opacity-100', 'pointer-events-auto');
    }

    function hideBanner() {
      cookieBanner.classList.add('translate-y-full', 'opacity-0', 'pointer-events-none');
      cookieBanner.classList.remove('translate-y-0', 'opacity-100', 'pointer-events-auto');
      // Details-Panel schließen
      if (detailsPanel) detailsPanel.style.gridTemplateRows = '0fr';
    }

    function applyConsent(consent) {
      // Shopify Customer Privacy API
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: false,
          marketing: consent.marketing,
          preferences: true
        }, function () {});
      }

      // Es werden keine Skripte von Fremdservern nachgeladen – der Shop kommt
      // ohne externe Dienste aus. Die Auswahl steuert nur Shopifys eigenes
      // Marketing-Tracking über die Customer-Privacy-API oben.
    }

    // Banner zeigen wenn noch keine Einwilligung
    var existingConsent = getCookieConsent();
    if (!existingConsent) {
      setTimeout(showBanner, 800);
    } else {
      applyConsent(existingConsent);
    }

    // Alle akzeptieren
    if (acceptAllBtn) {
      acceptAllBtn.addEventListener('click', function () {
        var consent = { essential: true, analytics: false, marketing: true };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Alle ablehnen (nur essenzielle)
    if (essentialOnlyBtn) {
      essentialOnlyBtn.addEventListener('click', function () {
        var consent = { essential: true, analytics: false, marketing: false };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Einstellungen aufklappen
    if (settingsBtn) {
      settingsBtn.addEventListener('click', function () {
        var isOpen = detailsPanel.style.gridTemplateRows === '1fr';
        detailsPanel.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
        var c = getCookieConsent();
        if (c && marketingToggle) marketingToggle.checked = c.marketing;
      });
    }

    // Auswahl speichern
    if (saveSettingsBtn) {
      saveSettingsBtn.addEventListener('click', function () {
        var consent = {
          essential: true,
          analytics: false,
          marketing: marketingToggle ? marketingToggle.checked : false
        };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Footer-Link: Cookie-Einstellungen erneut öffnen
    if (footerCookieBtn) {
      footerCookieBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var c = getCookieConsent();
        if (c && marketingToggle) marketingToggle.checked = c.marketing;
        detailsPanel.style.gridTemplateRows = '1fr';
        showBanner();
        cookieBanner.scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
    }
  }


  // -----------------------------------------------
  // 10. Wisch-Engine für Hero-Karussell und Hero-Slideshow
  //     Gemeinsame Basis: der Inhalt folgt dem Finger 1:1, schnappt danach
  //     weich ein und blättert von allein weiter. Gezeichnet wird Bild für Bild
  //     per requestAnimationFrame – dadurch gibt es keine hakeligen Übergänge
  //     zwischen CSS-Transition und Wischgeste mehr.
  // -----------------------------------------------
  function createSwipeDeck(config) {
    var root    = config.root;
    var surface = config.surface || config.root;
    var count   = config.count | 0;
    if (!root || !surface || count < 1) return null;

    var reduced  = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var loop     = count >= 3;                 // ab 3 Elementen endlos, darunter waere die Richtung mehrdeutig
    var autoplay = config.autoplay !== false && count > 1 && !reduced;
    var interval = config.interval || 5000;
    var dragCls  = config.dragClass   || 'is-dragging';
    var moveCls  = config.movingClass || 'is-moving';

    // Ohne automatisches Weiterblättern (Einstellung aus, nur ein Element oder
    // reduzierte Bewegung) bleibt der Fortschrittsbalken im Punkt einfach voll.
    if (!autoplay) root.classList.add(config.noAutoClass || 'is-noauto');

    var pos    = 0;      // Position im Karten-Raum, Kommazahlen erlaubt
    var index  = 0;
    var step   = 1;      // Pixel pro Karte
    var raf    = null;
    var anim   = null;
    var timer  = null;
    var inView = true;
    var paused = false;

    var down = false, pointerId = null, axis = null;
    var startX = 0, startY = 0, startPos = 0, lastX = 0, lastT = 0, velocity = 0, moved = 0;

    var AXIS_LOCK  = 8;    // px bis die Wischrichtung feststeht
    var CLICK_SLOP = 8;    // ab hier gilt die Geste als Ziehen, nicht als Klick

    function now() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }
    function norm(i) { return ((i % count) + count) % count; }

    function measure() {
      var s = config.measure ? config.measure() : root.clientWidth;
      step = (s && s > 0) ? s : 1;
    }

    function draw() {
      var i = norm(Math.round(pos));
      if (i !== index) {
        index = i;
        if (config.onIndex) config.onIndex(index);
      }
      config.render(pos, step, loop, count);
    }

    function requestDraw() {
      if (raf !== null || anim) return;
      raf = requestAnimationFrame(function () { raf = null; draw(); });
    }

    function setMoving(on) {
      if (on) { root.classList.add(moveCls); } else { root.classList.remove(moveCls); }
    }

    function cancelAnim() {
      if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
      anim = null;
    }

    function frame(t) {
      raf = null;
      if (!anim) { setMoving(false); return; }
      var p = (t - anim.start) / anim.dur;
      if (p >= 1) {
        pos = anim.to;
        anim = null;
        draw();
        setMoving(false);
        return;
      }
      // easeOutQuart: zügig los, sehr weich aus – wirkt am Handy am saubersten
      pos = anim.from + (anim.to - anim.from) * (1 - Math.pow(1 - p, 4));
      draw();
      raf = requestAnimationFrame(frame);
    }

    function animateTo(target, dur) {
      cancelAnim();
      if (!loop) {
        if (target < 0) target = 0;
        if (target > count - 1) target = count - 1;
      }
      var dist = Math.abs(target - pos);
      if (reduced || dist < 0.0005) {
        pos = target;
        draw();
        setMoving(false);
        return;
      }
      if (dur === undefined) dur = Math.min(780, Math.max(320, 320 + dist * 300));
      setMoving(true);
      anim = { from: pos, to: target, start: now(), dur: dur };
      raf = requestAnimationFrame(frame);
    }

    // Kürzesten Weg zum Ziel wählen – bei Endlos-Modus auch über den Rand hinweg
    function shortestTarget(target) {
      var base = Math.round(pos);
      if (!loop) return target;
      var d = norm(target - norm(base));
      if (d > count / 2) d -= count;
      return base + d;
    }

    function stop() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function start() {
      stop();
      if (!autoplay || !inView || down || paused || document.hidden) return;
      timer = setTimeout(function () {
        timer = null;
        if (!autoplay || !inView || down || paused || document.hidden) return;
        next();
      }, interval);
    }

    function restart() {
      if (config.onRestart) config.onRestart();
      start();
    }

    function goTo(target, dur) {
      animateTo(shortestTarget(norm(target)), dur);
      restart();
    }

    function next() {
      if (loop) { animateTo(Math.round(pos) + 1); restart(); }
      else { goTo(index >= count - 1 ? 0 : index + 1); }
    }

    function prev() {
      if (loop) { animateTo(Math.round(pos) - 1); restart(); }
      else { goTo(index <= 0 ? count - 1 : index - 1); }
    }

    // --- Ziehen / Wischen ---
    function endDrag(apply) {
      if (!down) return;
      down = false;
      root.classList.remove(dragCls);

      if (pointerId !== null) {
        try { surface.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
      }

      var target = Math.round(startPos);

      if (apply && axis === 'x') {
        target = Math.round(pos);
        // Lag der Finger vor dem Loslassen still, zählt der Schwung nicht mehr
        if (now() - lastT > 180) velocity = 0;
        if (Math.abs(velocity) > 0.28) {
          var dir = velocity < 0 ? 1 : -1;                       // Finger nach links = vorwärts
          target = dir > 0 ? Math.ceil(pos - 0.001) : Math.floor(pos + 0.001);
          if (target === Math.round(startPos)) target = Math.round(startPos) + dir;
        }
        var max = Math.round(startPos) + 2;
        var min = Math.round(startPos) - 2;
        if (target > max) target = max;
        if (target < min) target = min;
      }

      var fast = Math.abs(velocity) > 0.7;
      axis = null;
      velocity = 0;
      animateTo(target, fast ? 360 : undefined);
      restart();
    }

    function onDown(e) {
      moved = 0;                     // jede neue Beruehrung startet ohne Zieh-Historie
      if (config.ignore && config.ignore(e)) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (down) endDrag(false);

      cancelAnim();          // laufende Animation an Ort und Stelle übernehmen
      setMoving(true);
      down = true;
      pointerId = (e.pointerId === undefined) ? null : e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      startPos = pos;
      lastX = e.clientX;
      lastT = now();
      velocity = 0;
      moved = 0;
      axis = null;
      stop();
      // Pointer-Capture folgt erst, wenn die Geste wirklich ein Ziehen ist
    }

    function onMove(e) {
      if (!down) return;

      // Maustaste unterwegs losgelassen (z. B. ausserhalb des Fensters)
      if (e.pointerType === 'mouse' && e.buttons !== undefined && e.buttons === 0) {
        endDrag(true);
        return;
      }

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (axis === null) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') {
          // Vertikal: die Seite darf scrollen, das Deck hält sich raus
          endDrag(false);
          return;
        }
        root.classList.add(dragCls);
        if (pointerId !== null) {
          try { surface.setPointerCapture(pointerId); } catch (err) {}
        }
        startX = e.clientX;   // Lock-Schwelle nicht als Versatz mitschleppen
        dx = 0;
      }

      if (axis !== 'x') return;

      var t = now();
      var dt = t - lastT;
      if (dt > 0) {
        velocity = velocity * 0.6 + ((e.clientX - lastX) / dt) * 0.4;
        lastX = e.clientX;
        lastT = t;
      }

      var raw = startPos - dx / step;
      if (!loop) {
        // Am Anfang und Ende spürbar bremsen statt hart blockieren
        if (raw < 0) { raw = raw * 0.32; }
        else if (raw > count - 1) { raw = (count - 1) + (raw - (count - 1)) * 0.32; }
      }
      pos = raw;

      var abs = Math.abs(dx);
      if (abs > moved) moved = abs;
      requestDraw();
    }

    if (window.PointerEvent) {
      surface.addEventListener('pointerdown', onDown);
      surface.addEventListener('pointermove', onMove);
      surface.addEventListener('pointerup', function () { endDrag(true); });
      surface.addEventListener('pointercancel', function () { endDrag(false); });
      // Achtung: 'lostpointercapture' blubbert auch von Kind-Elementen hoch. Am Handy
      // hat der Browser den Pointer zuerst implizit auf das beruehrte Element gelegt –
      // sobald wir ihn auf die Wischflaeche umhaengen, meldet das Kind seinen Verlust.
      // Ohne diese Pruefung bricht genau dieses Ereignis jede Wischgeste sofort ab.
      surface.addEventListener('lostpointercapture', function (e) {
        if (e.target !== surface) return;
        if (pointerId !== null && e.pointerId !== undefined && e.pointerId !== pointerId) return;
        if (down) endDrag(true);
      });
      window.addEventListener('pointerup', function () { if (down) endDrag(true); });
      window.addEventListener('blur', function () { if (down) endDrag(false); });
    } else {
      surface.addEventListener('touchstart', function (e) {
        onDown({ pointerType: 'touch', clientX: e.touches[0].clientX, clientY: e.touches[0].clientY, target: e.target });
      }, { passive: true });
      surface.addEventListener('touchmove', function (e) {
        onMove({ pointerType: 'touch', clientX: e.touches[0].clientX, clientY: e.touches[0].clientY, target: e.target });
      }, { passive: true });
      surface.addEventListener('touchend', function () { endDrag(true); });
      surface.addEventListener('touchcancel', function () { endDrag(false); });
    }

    // Klick nach einer Ziehbewegung verwerfen, sonst öffnet sich ungewollt ein Produkt
    surface.addEventListener('click', function (e) {
      // Bedienelemente (Punkte, Pfeile) liegen bei der Slideshow innerhalb der
      // Wischflaeche – deren Klicks duerfen nie als Nachwehen einer Geste gelten
      if (config.ignore && config.ignore(e)) { moved = 0; return; }
      if (moved > CLICK_SLOP) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
        return;
      }
      moved = 0;
      if (config.onClick) config.onClick(e);
    }, true);

    surface.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // --- Tastatur ---
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });

    // Nur Tastaturfokus pausiert – Hover bewusst nicht, sonst bleibt es stehen,
    // sobald der Mauszeiger irgendwo darauf liegt.
    root.addEventListener('focusin', function () {
      var el = document.activeElement;
      var viaKeyboard = false;
      try { viaKeyboard = !!(el && el.matches && el.matches(':focus-visible')); } catch (err) {}
      if (viaKeyboard) {
        paused = true;
        root.classList.add(config.pauseClass || 'is-paused');
        stop();
      }
    });
    root.addEventListener('focusout', function () {
      paused = false;
      root.classList.remove(config.pauseClass || 'is-paused');
      start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) { start(); } else { stop(); }
        });
      }, { threshold: 0.15 }).observe(root);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { measure(); draw(); }, 120);
    });

    measure();
    if (config.onIndex) config.onIndex(0);
    draw();
    start();
    window.addEventListener('load', function () { measure(); draw(); });
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { measure(); draw(); });
    }

    return {
      goTo: goTo,
      next: next,
      prev: prev,
      start: start,
      stop: stop,
      getIndex: function () { return index; },
      getPos: function () { return pos; },
      remeasure: function () { measure(); draw(); }
    };
  }

  function readMs(el, prop, fallback) {
    var raw = parseFloat(getComputedStyle(el).getPropertyValue(prop));
    return (raw && raw > 0) ? raw : fallback;
  }

  // -----------------------------------------------
  // 10a. Hero Produkt-Karussell (Startseite)
  // -----------------------------------------------
  var hc = document.getElementById('hero-carousel');

  if (hc) {
    var hcTrack = hc.querySelector('.hc-track');
    var hcCards = Array.prototype.slice.call(hc.querySelectorAll('.hc-card'));
    var hcDots  = Array.prototype.slice.call(hc.querySelectorAll('.hc-dot'));
    var hcCount = hcCards.length;

    if (hcTrack && hcCount > 0) {
      // Browser-eigenes Bild-Dragging abschalten (stört den Swipe)
      Array.prototype.forEach.call(hc.querySelectorAll('img'), function (img) {
        img.setAttribute('draggable', 'false');
      });

      var hcDeck = createSwipeDeck({
        root: hc,
        surface: hcTrack,
        count: hcCount,
        interval: readMs(hc, '--hc-interval', 5000),
        autoplay: hc.classList.contains('hc-auto-setting'),
        dragClass: 'hc-dragging',
        movingClass: 'hc-moving',
        pauseClass: 'hc-paused',
        noAutoClass: 'hc-noauto',

        measure: function () {
          var w   = hcCards[0].offsetWidth || 380;
          var gap = parseFloat(getComputedStyle(hc).getPropertyValue('--hc-gap')) || 20;
          return w + gap;
        },

        render: function (pos, step, loop, count) {
          // Wie weit eine Karte vom Zentrum weg sein darf, bis sie ausserhalb des
          // Bildschirms liegt. Dadurch zeigen schmale Karten automatisch mehr Nachbarn.
          var halb = (hc.clientWidth || window.innerWidth || 0) / 2;
          var reichweite = (halb + step * 0.6) / step;
          if (reichweite < 1.05) reichweite = 1.05;
          if (reichweite > 4) reichweite = 4;

          for (var i = 0; i < count; i++) {
            var card = hcCards[i];
            var off  = i - pos;
            if (loop) { off -= count * Math.round(off / count); }

            var dist    = Math.abs(off);
            var clamped = dist < 3 ? dist : 3;
            var visible = dist < reichweite;

            card.style.transform =
              'translate3d(calc(-50% + ' + (off * step).toFixed(1) + 'px), 0, 0) scale(' +
              (1 - clamped * 0.05).toFixed(4) + ')';
            card.style.opacity       = visible ? Math.max(0.12, 1 - dist * 0.3).toFixed(3) : '0';
            card.style.zIndex        = String(100 - Math.round(dist * 10));
            card.style.pointerEvents = visible ? 'auto' : 'none';

            var isActive = dist < 0.5;
            if (isActive) { card.classList.add('is-active'); } else { card.classList.remove('is-active'); }
            card.setAttribute('aria-hidden', isActive ? 'false' : 'true');

            var link = card.querySelector('.hc-title-link');
            if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
            var cta = card.querySelector('.hc-cta');
            if (cta && !cta.disabled) cta.setAttribute('tabindex', isActive ? '0' : '-1');
          }
        },

        onIndex: function (i) {
          hcDots.forEach(function (dot, n) {
            var on = n === i;
            if (on) { dot.classList.add('is-active'); } else { dot.classList.remove('is-active'); }
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        },

        // Fortschrittsbalken im aktiven Punkt von vorn starten
        onRestart: function () {
          var fill = hc.querySelector('.hc-dot.is-active .hc-dot-fill');
          if (!fill) return;
          fill.style.animation = 'none';
          void fill.offsetWidth;
          fill.style.animation = '';
        },

        // Klick auf eine Nachbarkarte zentriert sie, statt das Produkt zu öffnen
        onClick: function (e) {
          var card = e.target.closest ? e.target.closest('.hc-card') : null;
          if (card && !card.classList.contains('is-active')) {
            e.preventDefault();
            e.stopPropagation();
            hcDeck.goTo(hcCards.indexOf(card));
          }
        }
      });

      Array.prototype.forEach.call(hc.querySelectorAll('.hc-prev'), function (btn) {
        btn.addEventListener('click', function () { hcDeck.prev(); });
      });
      Array.prototype.forEach.call(hc.querySelectorAll('.hc-next'), function (btn) {
        btn.addEventListener('click', function () { hcDeck.next(); });
      });
      hcDots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { hcDeck.goTo(i); });
      });
    }
  }

  // -----------------------------------------------
  // 10b. Hero Slideshow (Startseite, alternative Ansicht)
  // -----------------------------------------------
  var hs = document.getElementById('hero-slideshow');

  if (hs) {
    var hsSlides = Array.prototype.slice.call(hs.querySelectorAll('.hs-slide'));
    var hsCopies = Array.prototype.slice.call(hs.querySelectorAll('.hs-copy'));
    var hsDots   = Array.prototype.slice.call(hs.querySelectorAll('.hs-dot'));
    var hsCount  = hsSlides.length;

    if (hsCount > 0) {
      Array.prototype.forEach.call(hs.querySelectorAll('img'), function (img) {
        img.setAttribute('draggable', 'false');
      });

      var hsDeck = createSwipeDeck({
        root: hs,
        surface: hs,
        count: hsCount,
        interval: readMs(hs, '--hs-interval', 6000),
        autoplay: !hs.classList.contains('hs-noauto'),
        dragClass: 'hs-dragging',
        movingClass: 'hs-moving',
        pauseClass: 'hs-paused',
        noAutoClass: 'hs-noauto',

        // Punkte und Pfeile sollen klickbar bleiben und keinen Wisch auslösen
        ignore: function (e) {
          return !!(e.target && e.target.closest && e.target.closest('.hs-dot, .hs-arrow'));
        },

        measure: function () {
          return hs.clientWidth || window.innerWidth || 1;
        },

        render: function (pos, step, loop, count) {
          for (var i = 0; i < count; i++) {
            var slide = hsSlides[i];
            var off   = i - pos;
            if (loop) { off -= count * Math.round(off / count); }

            var dist = Math.abs(off);
            slide.style.transform  = 'translate3d(' + (off * step).toFixed(1) + 'px, 0, 0)';
            slide.style.opacity    = dist < 1.02 ? '1' : '0';
            slide.style.zIndex     = String(10 - Math.round(dist * 5));
            slide.style.visibility = dist < 1.3 ? 'visible' : 'hidden';

            // Bild wandert langsamer als die Slide – gibt dem Wischen Tiefe.
            // Im Modus „ganzes Bild zeigen" bleibt es unangetastet, sonst wuerde
            // der Zoom genau das abschneiden, was sichtbar bleiben soll.
            var img = slide.querySelector('.hs-img');
            if (img) {
              img.style.transform = slide.classList.contains('hs-slide-contain')
                ? ''
                : 'scale(1.1) translate3d(' + (-off * step * 0.08).toFixed(1) + 'px, 0, 0)';
            }
          }
        },

        onIndex: function (i) {
          hsCopies.forEach(function (copy, n) {
            var on = n === i;
            if (on) { copy.classList.add('is-active'); } else { copy.classList.remove('is-active'); }
            var btn = copy.querySelector('.hs-btn');
            if (btn) btn.setAttribute('tabindex', on ? '0' : '-1');
          });
          hsDots.forEach(function (dot, n) {
            var on = n === i;
            if (on) { dot.classList.add('is-active'); } else { dot.classList.remove('is-active'); }
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        },

        onRestart: function () {
          var fill = hs.querySelector('.hs-dot.is-active .hs-dot-fill');
          if (!fill) return;
          fill.style.animation = 'none';
          void fill.offsetWidth;
          fill.style.animation = '';
        }
      });

      Array.prototype.forEach.call(hs.querySelectorAll('.hs-prev'), function (btn) {
        btn.addEventListener('click', function () { hsDeck.prev(); });
      });
      Array.prototype.forEach.call(hs.querySelectorAll('.hs-next'), function (btn) {
        btn.addEventListener('click', function () { hsDeck.next(); });
      });
      hsDots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { hsDeck.goTo(i); });
      });

      // Handy-Adressleiste ändert die Höhe -> Breite neu messen
      window.addEventListener('orientationchange', function () {
        setTimeout(function () { hsDeck.remeasure(); }, 200);
      });
    }
  }

});
